import { LogoImage } from '@logo-current';
import type { LogoProps } from './types';

// Фасад над per-theme логотипом (@logo-current → Logo/<theme>). За алиасом
// компонент, а не файл: разметка у тем разная — у serious знак + отдельный SVG с
// текстом, у wap одна картинка фиксированного размера.
//
// Раньше выбор шёл рантайм-тернаром по isBlueTheme, а размеры — префиксами
// t-blue:/t-green: в одном классе. Из-за этого оба логотипа лежали в каждом
// артефакте (пункт «ассеты обоих брендов в бандле» из ревью 31.07).
export const Logo = ({ min, size, className }: LogoProps) => (
  <LogoImage min={min} size={size} className={className} />
);
